import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {editCustomer} from 'web/redux/actions/CustomerActions';
import validateCoordinates from 'web/utils/validateCoordinates';

/**
 *
 */
export default function CoordinatesModal({
  isOpen,
  onOpenChange = () => {},
  selectedCustomerData,
}) {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [errorMsg, setErrorMsg] = useState([]);
  const dispatch = useDispatch();

  const locationModalRef = useRef(null);

  const resetForm = () => {
    setLatitude(null);
    setLongitude(null);
    setErrorMsg([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const basicValidation = validateCoordinates(latitude, longitude);
    if (!basicValidation.isValid) {
      return setErrorMsg(basicValidation.errors);
    }
    const customer = {
      ...selectedCustomerData,
      latitude,
      longitude,
    };
    try {
      const res = await dispatch(
        editCustomer({customer, isCoordinateOnly: true}),
      ).unwrap();
      if (res.code.isSuccessCode()) {
        resetForm();
        return onOpenChange(false);
      }
    } catch (error) {
      console.error(error.response.data);
    }
  };

  const onClose = (e) => {
    onOpenChange(false);
    locationModalRef.current.hide();
    // resetForm();
  };

  useEffect(() => {
    if (locationModalRef.current) {
      locationModalRef.current = new bootstrap.Modal(locationModalRef.current);
    }
  }, []);

  useEffect(() => {
    if (isOpen && locationModalRef.current) {
      locationModalRef.current.show();
    } else {
      onClose();
    }
  }, [isOpen]);

  return (
    <div
      ref={locationModalRef}
      className="modal fade"
      id="modalSatisfaction"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalSatisfactionLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalSatisfactionForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalSatisfactionLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href="#ico-edit"></use>
                </svg>
              </div>
              <div className="modal__title__text">填寫經緯度</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="row">
                <div className="col-12">
                  <label htmlFor="caseNumber" className="form-label">
                    客戶名稱
                  </label>
                  <input
                    type="text"
                    disabled
                    className="form-control form-control-sm"
                    value={selectedCustomerData?.customerName || ''}
                    id="caseNumber"
                  />
                </div>
                <div className="col-12 d-flex gap-3">
                  <div className="col-6">
                    <label
                      htmlFor="customer-modal-longitude"
                      className="form-label"
                    >
                      經度*
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="customer-modal-longitude"
                      name="modalLongitude"
                      defaultValue={selectedCustomerData?.longitude || ''}
                      value={longitude || ''}
                      onChange={(e) => {
                        let value = parseFloat(e.target.value);
                        if (Number.isNaN(value)) {
                          value = null;
                        }
                        setLongitude(value);
                      }}
                      required
                    />
                  </div>
                  <div className="col-6">
                    <label
                      htmlFor="customer-modal-latitude"
                      className="form-label"
                    >
                      緯度*
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      id="customer-modal-latitude"
                      name="modalLatitude"
                      defaultValue={selectedCustomerData?.latitude || ''}
                      value={latitude || ''}
                      onChange={(e) => {
                        let value = parseFloat(e.target.value);
                        if (Number.isNaN(value)) {
                          value = null;
                        }
                        setLatitude(value);
                      }}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer gap-2">
            <div className="w-50 p-2 text-danger fs-bold fs-6 ">
              {errorMsg?.map((msg, index) => (
                <p className="mb-1" key={index}>
                  {msg}
                </p>
              ))}
            </div>
            <button type="submit" className="btn btn-primary w-50 text-right">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
